// extracted by mini-css-extract-plugin
module.exports = {"value":"table-row_value__3Ryg4","values":"table-row_values__1gq3q","date":"table-row_date__3ut9i","row":"table-row_row__VX2FO","chip":"table-row_chip__r0L0p"};